import React from "react";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material";

import EnrollButton from "../../../bootcamps/components/detail/common/EnrollButton";
import StickyNavbar from "../../../common/components/navbar/StickyNavbar";
import useScrollHandler from "../../../common/custom-hooks/useScrollHandler";
import authService from "../../../common/service/authService";
import useJoinCourse from "../custom-hooks/useJoinCourse";
import EnrollActions from "./common/EnrollActions";

const Navbar: React.FC<
  NSNavbar.INavbar & {
    userEnrolled: boolean;
    slug: string;
  } & NSCourses.IEnrollFormProps
> = ({ onTabChange, tabIdx, userEnrolled, slug, enrollUrl }) => {
  const theme = useTheme();
  const { state: navbar, ref: navbarRef } = useScrollHandler();

  const tabs = [
    {
      label: "About",
      route: "about",
    },
    {
      label: "What You Will Learn?",
      route: "what-will-you-learn",
    },
    {
      label: "Course Content",
      route: "course-content",
    },
    {
      label: "Success Stories",
      route: "success-stories",
    },
  ];

  return (
    <>
      <div ref={navbarRef} />
      <StickyNavbar
        tabs={tabs}
        tabIdx={tabIdx}
        onTabChange={onTabChange}
        containerProps={{
          sx: {
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          },
        }}
      >
        {navbar &&
          (authService.isAuthenticated ? (
            <EnrollActions
              slug={slug}
              enrollUrl={enrollUrl}
              userEnrolled={userEnrolled}
            />
          ) : (
            <EnrollButton
              href="#enroll"
              sx={{ p: theme.spacing(1, 3), height: 35, width: 158 }}
            >
              Enroll For Free
            </EnrollButton>
          ))}
      </StickyNavbar>
    </>
  );
};

export default Navbar;
